import { viewActionTypes } from '../actions/view-action-types';

const initialAlbumViewState = {
	images: new Map(),
	albumId: -1,
	currentImageId: [],
	slideShow: false,
	rightOpen: false,
	currentItemShown:0,
	rotateShow: false,
	videoEditorOpen: false
};

export const albumImages = (state = initialAlbumViewState, action) => {
	switch (action.type) {
		case viewActionTypes.ALBUM_IMAGE_RECEIVED:
			return {...state, images: addImageElementToNewMap(state, action)};
		case viewActionTypes.TOGGLE_SLIDE_SHOW:
			return {...state, slideShow: !state.slideShow};
			case viewActionTypes.TOGGLE_RIGHT_OPEN:
			return {...state, rightOpen: action.status};
			case viewActionTypes.TOGGLE_ROTATE:
			return {...state, rotateShow: !state.rotateShow};
			case viewActionTypes.UPDATE_CURRENT_ITEM_SHOWN_MEDIA_PLAYER:
			return{...state, currentItemShown: action.itemId};
		case viewActionTypes.TOGGLE_VIDEO_EDITOR:
			return {...state, videoEditorOpen: !state.videoEditorOpen}
			
		default:
			return state;
	}
};

const addImageElementToNewMap = (state, action) => {
    let returnMap = new Map(state.images.entries());
    returnMap.set(action.id, action.element);
    return returnMap;
};



// WEBPACK FOOTER //
// ./src/view/reducers/view-reducers.js